export const SERVICE_URL = process.env.SERVICE_URL;

export const ACTION_ADD_ALERT = "ACTION_ADD_ALERT";
export const ACTION_DISMISS_ALERT = "ACTION_DISMISS_ALERT";
export const ACTION_SET_BUSY = "ACTION_SET_BUSY";
export const ACTION_SET_SEARCHING = "ACTION_SET_SEARCHING";
export const ACTION_SET_CATEGORIES = "ACTION_SET_CATEGORIES";
export const ACTION_SET_SEARCH_RESULTS = "ACTION_SET_SEARCH_RESULTS";

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";
export const VALIDATION_ZIP = /^\d{5}$|^\d{5}-\d{4}$/;
